import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SOURCE_DOCUMENT_SCHEMA = Object.freeze({
  TYPE: '', // documentType as string
  LOCAL_ID: '',
  ID: '',
  REVISION_ID: '',
  TRIGGERED_BY: '',
});
export const RECORD = generateSchema(SOURCE_DOCUMENT_SCHEMA);
export const KEYS: any = generateKeys(SOURCE_DOCUMENT_SCHEMA);

export class SourceDocument extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get localId(): string {
    return this.get(KEYS.LOCAL_ID);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  get triggeredBy(): string {
    return this.get(KEYS.TRIGGERED_BY);
  }
}
